<label *ngIf="appendLabel" [class.success]="showSuccess" class="input-label">
  {{ _labelName }} <span *ngIf="flagAsRequired">*</span>
</label>

<div [ngClass]="orientation" class="radio-group">
  <div *ngFor="let item of values" class="checkbox-container">
    <label
      *ngIf="labelPosition === 'before' && appendLabel"
      class="input-label label-before">
      {{ item.label }}
    </label>

    <input
      [formControlName]="inputName"
      [id]="inputName + item.value"
      [name]="inputName"
      [value]="item.value"
      class="custom-control-input"
      type="radio" />

    <label
      *ngIf="labelPosition === 'after' && appendLabel"
      class="input-label label-after">
      {{ item.label }}
    </label>
  </div>
</div>
